module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "powered-by-mikmak-white",
    attrs: {
      "id": "powered-by-mikmak-white"
    }
  }, [_c('label', {
    staticClass: "powered-by-mikmak-text"
  }, [_vm._v(_vm._s(_vm.poweredByText))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/mikmak-logo-white.png"),
      "alt": "powered by MikMak"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d6fdc74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/PoweredByMikMak.vue
// module id = 40
// module chunks = 0